import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { images } from '../assets/images';
import './CTA.css';

export interface Props {
  title?: string
  subtitle?: string
  button?: string
  image?: string
  link?: string
}

function CTA(props : Props) {
  const { t, i18n } = useTranslation();
  if (props.image !== undefined) {
    return (
      <div className="CTAImage">
        <div className='left'>
        </div>
        <div className='right'>
          <div>
            <h2>{props.title === null ? "Contact us" : props.title}</h2>
            <p>{props.subtitle === null ? "Lorem" : props.subtitle}</p>
          </div>
          {props.link !== undefined?
          <a href={t(props.link)} target="_blank" className='right primary green'>{props.button === null ? "Leave a message" : props.button}</a>
          :null}
          {/* <Link to="/contacts" className='right primary green'>{props.button === null ? "Leave a message" : props.button}</Link> */}
        </div>
      </div>
    );
  
  }
  else {
    return (
      <div className="CTA" style={{
        backgroundImage: `url(${images.side})`
      }}>
        <div className='left'>
          <h2>{props.title === null ? "Contact us" : props.title}</h2>
          <p>{props.subtitle === null ? "Lorem" : props.subtitle}</p>
        </div>
          <Link to="/contacts" className='right primary green mt-5'>{props.button === null ? "Leave a message" : props.button}</Link>
      </div>
    );
  }   
}
 

export default CTA;
